"use client";
import { j as d } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as m } from "./tv.config-BuYIgndg.mjs";
import { u as c } from "./useRender-DCcXqLqs.mjs";
import { m as u } from "./useRenderElement-B8V3_e8R.mjs";
const h = m({
  base: [
    "focus-visible:appearance-none",
    "focus-visible:right-0",
    "focus-visible:border-none",
    "focus-visible:outline-none"
  ],
  variants: {
    variant: {
      h1: "text-5xl",
      h2: "text-4xl",
      h3: "text-3xl",
      h4: "text-2xl",
      h5: "text-xl",
      h6: "text-lg",
      subtitle1: "text-lg",
      subtitle2: "text-lg",
      body1: "text-sm",
      body2: "text-md",
      caption: ["text-xs"],
      inherit: "text-inherit"
    },
    underline: {
      always: "underline",
      hover: "hover:underline",
      none: "no-underline"
    },
    color: {
      primary: "text-primary-main hover:text-primary-dark",
      secondary: "text-secondary-main hover:text-secondary-dark",
      success: "text-green-main hover:text-green-dark",
      warning: "text-orange-main hover:text-orange-dark",
      info: "text-sky-main hover:text-sky-dark",
      error: "text-red-main hover:text-red-dark"
    }
  },
  defaultVariants: {
    variant: "body2",
    underline: "none"
  }
}), g = (e) => {
  const { render: t, variant: r, underline: n, color: o, className: a, children: s, ...i } = e, l = t ?? /* @__PURE__ */ d.jsx("a", {}), x = {
    children: s,
    className: h({ variant: r, underline: n, color: o, class: a })
  };
  return c({
    render: l,
    props: u(x, i)
  });
};
export {
  g as default
};
